"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
var _jsxruntime = require("react/jsx-runtime");
var _react = /*#__PURE__*/ _interop_require_wildcard(require("react"));
var _link = /*#__PURE__*/ _interop_require_default(require("next/link"));
var _core = require("@mantine/core");
var _index = require("../../assets/icons/index");
var _headermodulecss = /*#__PURE__*/ _interop_require_default(require("../../../dist/assets/components/header.module.css"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
var Header = function(param) {
    var items = param.items, logo = param.logo, onClickSignout = param.onClickSignout;
    var _useState = (0, _react.useState)(false), menuOpened = _useState[0], setMenuOpened = _useState[1];
    var title = menuOpened ? "Close navigation" : "Open navigation";
    var _items_length;
    return /*#__PURE__*/ (0, _jsxruntime.jsxs)(_jsxruntime.Fragment, {
        children: [
            /*#__PURE__*/ (0, _jsxruntime.jsxs)("header", {
                className: _headermodulecss.default.header,
                children: [
                    /*#__PURE__*/ (0, _jsxruntime.jsx)(_link.default, {
                        href: "/",
                        className: _headermodulecss.default.logo,
                        children: logo
                    }),
                    /*#__PURE__*/ (0, _jsxruntime.jsxs)("nav", {
                        className: _headermodulecss.default.nav,
                        children: [
                            /*#__PURE__*/ (0, _jsxruntime.jsx)(_core.Anchor, {
                                component: _link.default,
                                href: "/search",
                                variant: "text",
                                size: "sm",
                                color: "white",
                                children: /*#__PURE__*/ (0, _jsxruntime.jsx)(_index.Search, {})
                            }),
                            /*#__PURE__*/ (0, _jsxruntime.jsx)(_core.Burger, {
                                opened: menuOpened,
                                onClick: function() {
                                    return setMenuOpened(true);
                                },
                                title: title
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxruntime.jsxs)(_core.Drawer, {
                opened: menuOpened,
                position: "right",
                onClose: function() {
                    return setMenuOpened(false);
                },
                padding: "xl",
                size: "xl",
                withCloseButton: false,
                classNames: {
                    root: _headermodulecss.default.root,
                    close: _headermodulecss.default.close,
                    body: _headermodulecss.default.drawerBody,
                    inner: _headermodulecss.default.inner
                },
                children: [
                    /*#__PURE__*/ (0, _jsxruntime.jsxs)("div", {
                        className: _headermodulecss.default.drawerHeader,
                        children: [
                            logo,
                            /*#__PURE__*/ (0, _jsxruntime.jsx)(_core.Burger, {
                                color: "#ffffff",
                                opened: menuOpened,
                                onClick: function() {
                                    return setMenuOpened(false);
                                },
                                title: title
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxruntime.jsx)("div", {
                        className: _headermodulecss.default.drawerList,
                        children: ((_items_length = items == null ? void 0 : items.length) != null ? _items_length : 0 > 0) && /*#__PURE__*/ (0, _jsxruntime.jsx)(_core.List, {
                            classNames: {
                                itemWrapper: _headermodulecss.default.itemWrapper,
                                itemIcon: _headermodulecss.default.itemIcon
                            },
                            onClick: function() {
                                return setMenuOpened(false);
                            },
                            children: items == null ? void 0 : items.map(function(param) {
                                var link = param.link, label = param.label, icon = param.icon;
                                return /*#__PURE__*/ (0, _jsxruntime.jsx)(_core.List.Item, {
                                    icon: icon,
                                    children: /*#__PURE__*/ (0, _jsxruntime.jsx)(_core.Anchor, {
                                        component: _link.default,
                                        href: link,
                                        variant: "text",
                                        color: "#112132",
                                        size: "sm",
                                        children: label
                                    })
                                }, "headerItem-" + link);
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxruntime.jsx)(_core.Box, {
                        style: {
                            width: "100%",
                            display: "flex",
                            justifyContent: "stretch",
                            borderTop: "1px solid #cccccc",
                            padding: 15,
                            marginTop: "auto"
                        },
                        children: /*#__PURE__*/ (0, _jsxruntime.jsxs)(_core.Box, {
                            onClick: onClickSignout,
                            className: "logout",
                            role: "button",
                            style: {
                                width: "100%",
                                display: "flex",
                                justifyContent: "flex-start",
                                alignItems: "center"
                            },
                            children: [
                                /*#__PURE__*/ (0, _jsxruntime.jsx)(_index.Logout, {
                                    color: "#112132"
                                }),
                                /*#__PURE__*/ (0, _jsxruntime.jsx)(_core.Text, {
                                    style: {
                                        color: "#112132",
                                        marginLeft: "1rem",
                                        marginRight: "0.5rem",
                                        flex: "1 1 100%"
                                    },
                                    children: "Signout"
                                }),
                                /*#__PURE__*/ (0, _jsxruntime.jsx)(_index.ChevronRight, {
                                    color: "#112132"
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
var _default = Header;
